
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rsldashboard/db-cardDetails",
      function () {
        return require("private-next-pages/rsldashboard/db-cardDetails/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rsldashboard/db-cardDetails"])
      });
    }
  